import gql from 'graphql-tag';

export default gql ` 
query getActivityHelp($id: ID!){
    getActivityHelp(id: $id){
        id
        actDate
        username
        activityType
        value
        intensity
        notes
        timestamp
    }
}`;


// WEBPACK FOOTER //
// ./src/components/queries/GetActivityHelpQuery.js